import React from "react";
import { Checkbox, Typography } from "antd";

const { Text } = Typography;

const CustomCheckBox = ({
  id,
  label,
  checked,
  onChange,
  disabled,
  labelColor = "#000",
  showRequired = false,
  showOptional = false,
  errorMessage,
  className,
}) => {
  return (
    <div className={className}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
        <Checkbox
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        {label && (
          <div style={{ fontWeight: 400, color: labelColor }}>
            {label}
            {showRequired ? (
              <span style={{ color: "red" }}>*</span>
            ) : showOptional ? (
              <span style={{ color: "#8C8C8C" }}>
                {typeof showOptional === "string" ? ` ${showOptional}` : " (Optional)"}
              </span>
            ) : null}
          </div>
        )}
      </div>
      {errorMessage && (
        <Text type="danger" style={{ display: "block", marginTop: 4 }}>
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default CustomCheckBox;
